import React from 'react';
import { Grid, IconButton, makeStyles, TextField, Typography } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { format } from 'date-fns';
import DayIcon from './DayIcon';
import {
  DeleteOutlineOutlined as DeleteIcon
} from '@material-ui/icons';


const DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    marginBottom: theme.spacing(3)
  },
  label: {
    textAlign: 'center'
  },
  days: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center'
  }
}));


/**
 * Display Timesegment
 * @param {title, data, edit, remove} props A Timesegment entity.
 */
function Timesegment(props) {
  const { title, data, edit, remove } = props;
  const classes = useStyles();

  const timeToDate = (time) => {
    const split = time.split(':');
    const date = new Date()
    date.setHours(parseInt(split[0]));
    date.setMinutes(parseInt(split[1]));
    date.setSeconds(0);
    return date;
  }

  const dateToTime = (date) => {
    return format(date, 'HH:mm:ss');
  }

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        <Typography variant='h6'>{title}</Typography>

        <IconButton
          title='Delete'
          onClick={remove}
        >
          <DeleteIcon />
        </IconButton>
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <KeyboardTimePicker
            variant='inline'
            inputVariant='outlined'
            label='Start Time'
            fullWidth
            value={timeToDate(data.startTime)}
            onChange={val => edit('startTime', dateToTime(val))}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <KeyboardTimePicker
            variant='inline'
            inputVariant='outlined'
            label='End Time'
            fullWidth
            value={timeToDate(data.endTime)}
            onChange={val => edit('endTime', dateToTime(val))}
          />
        </Grid>


        <Grid item xs={4}>
          <TextField
            label='Interval (minutes)'
            variant='outlined'
            type='number'
            value={data.interval}
            onChange={evt => edit('interval', parseInt(evt.target.value))}
          />
        </Grid>

        <Grid item xs={8} className={classes.days}>
          {DAYS.map((day, idx) => 
            <DayIcon
              key={idx}
              day={day}
              selected={data.days.includes(idx)}
              toggle={() => edit('days', idx)}
            />)}
        </Grid>
      </Grid>
    </div>
  );
}

export default Timesegment;
